module.exports = __webpack_public_path__ + "static/bett1aces-unboxing-467a91d65c54efdab308fcd573cd71ec.jpg";